import AppDispatcher from "./AppDispatcher";

class AppActions {

    updateOddsLadder(data) {
        AppDispatcher.dispatch({
            actionType: "UPDATE_ODDSLADDER",
            value: data
        });
    }

    selectPrices(data) {
        AppDispatcher.dispatch({
            actionType: "SELECT_PRICES",
            value: data
        });
    }

    setSportsbookPrices(data) {
        AppDispatcher.dispatch({
            actionType: "SET_SB_PRICES",
            value: data
        });
    }

    updatePreferences(data) {
        AppDispatcher.dispatch({
            actionType: "UPDATE_PREFERENCES",
            value: data
        });
    }

    setExCouponPriceView(data) {
        AppDispatcher.dispatch({
            actionType: "SET_PRICE_VIEW",
            value: data
        });
    }
}


export default new AppActions();